"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_intersection_observer_1 = require("react-intersection-observer");
var card_module_1 = __importDefault(require("../../../modules/cards/card.module"));
var index_module_scss_1 = __importDefault(require("../index.module.scss"));
var i18next_1 = require("i18next");
function Content() {
    var _a = (0, react_intersection_observer_1.useInView)({
        rootMargin: "0px 0px",
    }), ref = _a.ref, inView = _a.inView;
    var list = (0, i18next_1.t)("starsMusic.list", { returnObjects: true });
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.items }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.container, ref: ref, style: inView
                    ? {
                        transform: "scale(1)",
                        filter: "grayscale(0)",
                        transition: "ease-in-out 0.5s",
                    }
                    : {
                        transform: "scale(0.8)",
                        filter: "grayscale(1)",
                        opacity: "0.5",
                        transition: "ease-in-out 0.8s",
                    } }, { children: [(0, jsx_runtime_1.jsx)("h3", { dangerouslySetInnerHTML: { __html: (0, i18next_1.t)("starsMusic.contentTitle") } }), (0, jsx_runtime_1.jsx)(card_module_1.default, { list: list })] })) })) }));
}
exports.default = Content;
